import { useState, type ChangeEvent, type KeyboardEvent } from "react";

// Holds free-typed text locally and only calls `commit` on blur/Enter (MICS-166).
export function useCommittedNumberInput(value: number, commit: (v: number) => void) {
  const [draft, setDraft] = useState<string | null>(null);

  const flush = () => {
    if (draft === null) return;
    const n = Number(draft);
    if (draft.trim() !== "" && Number.isFinite(n)) commit(n);
    setDraft(null);
  };

  return {
    value: draft ?? String(value),
    onChange: (e: ChangeEvent<HTMLInputElement>) => setDraft(e.target.value),
    onBlur: flush,
    onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") flush();
      else if (e.key === "Escape") setDraft(null);
    },
  };
}
